/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Live_Platform_Blurb_FailoverInputs */

const en_live_platform_blurb_failover = /** @type {(inputs: Live_Platform_Blurb_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} data through one normalized API - per-request USD pricing, no subscriptions, and automatic failover on redundant endpoints.`)
};

const zh_hans1_live_platform_blurb_failover = /** @type {(inputs: Live_Platform_Blurb_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`通过一个标准化 API 获取 ${i?.name} 数据：按请求以美元计价，无需订阅，有冗余的接口支持自动切换。`)
};

const pt_br2_live_platform_blurb_failover = /** @type {(inputs: Live_Platform_Blurb_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dados de ${i?.name} em uma única API normalizada: preço por requisição em dólares, sem assinatura e failover automático nos endpoints redundantes.`)
};

const es_live_platform_blurb_failover = /** @type {(inputs: Live_Platform_Blurb_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Datos de ${i?.name} a través de una sola API normalizada, con precio por solicitud en USD, sin suscripciones y con respaldo automático en endpoints redundantes.`)
};

const fr_live_platform_blurb_failover = /** @type {(inputs: Live_Platform_Blurb_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les données ${i?.name} via une seule API normalisée - tarification en USD par requête, sans abonnement, et basculement automatique sur les endpoints redondants.`)
};

const de_live_platform_blurb_failover = /** @type {(inputs: Live_Platform_Blurb_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-Daten über eine normalisierte API, mit Preis pro Anfrage in USD, ohne Abos und mit automatischem Failover bei redundanten Endpoints.`)
};

const ru_live_platform_blurb_failover = /** @type {(inputs: Live_Platform_Blurb_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Данные ${i?.name} через один нормализованный API: цена за запрос в долларах США, никаких подписок и автоматическое переключение на дублирующих эндпоинтах.`)
};

const it_live_platform_blurb_failover = /** @type {(inputs: Live_Platform_Blurb_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I dati di ${i?.name} attraverso un'unica API normalizzata - prezzo a richiesta in USD, nessun abbonamento e failover automatico sugli endpoint ridondanti.`)
};

/**
* | output |
* | --- |
* | "{name} data through one normalized API - per-request USD pricing, no subscriptions, and automatic failover on redundant endpoints." |
*
* @param {Live_Platform_Blurb_FailoverInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const live_platform_blurb_failover = /** @type {((inputs: Live_Platform_Blurb_FailoverInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Platform_Blurb_FailoverInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_live_platform_blurb_failover(inputs)
	if (locale === "pt-BR") return pt_br2_live_platform_blurb_failover(inputs)
	if (locale === "es") return es_live_platform_blurb_failover(inputs)
	if (locale === "fr") return fr_live_platform_blurb_failover(inputs)
	if (locale === "de") return de_live_platform_blurb_failover(inputs)
	if (locale === "ru") return ru_live_platform_blurb_failover(inputs)
	if (locale === "it") return it_live_platform_blurb_failover(inputs)
	return en_live_platform_blurb_failover(inputs)
});